import { useState, useEffect } from 'react';

export const usePerformanceOptimization = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasOptimizedImages, setHasOptimizedImages] = useState(false);

  useEffect(() => {
    // Intersection Observer for lazy loading
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    // Optimize images for better loading
    const optimizeImages = () => {
      const images = document.querySelectorAll('img[data-src]');
      images.forEach((img) => {
        const imgElement = img as HTMLImageElement;
        if (imgElement.dataset.src) {
          imgElement.src = imgElement.dataset.src;
          imgElement.removeAttribute('data-src');
        }
      });
      setHasOptimizedImages(true);
    };

    // Defer non-critical resources
    const deferNonCritical = () => {
      // Defer analytics and non-critical scripts
      setTimeout(() => {
        const scripts = document.querySelectorAll('script[data-defer]');
        scripts.forEach((script) => {
          const newScript = document.createElement('script');
          newScript.src = script.getAttribute('data-defer') || '';
          document.head.appendChild(newScript);
          script.remove();
        });
      }, 1000);
    };

    optimizeImages();
    deferNonCritical();

    return () => {
      observer.disconnect();
    };
  }, []);

  return { isVisible, hasOptimizedImages };
};

// Preload critical resources
export const preloadCriticalResources = () => {
  if (typeof window === 'undefined') return;

  const criticalImages = [
    '/images/logo.png', // Logo
    '/images/daniel.png', // Daniel's photo
  ];

  criticalImages.forEach((src) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
};